import { Box, useTheme } from '@vitvio/design-system';
import { SidebarDebugIcon } from '@vitvio/demo-functionality';
import { SidebarNavigation } from '@vitvio/navigation';
import { AvatarMenuWithButton } from '@vitvio/shared-components';

export function MissionControlSidebar() {
  const { getSpacing } = useTheme();
  return (
    <>
      <SidebarNavigation />

      <Box display={'flex'} flexDir={'column'} mt={'auto'} mb={getSpacing('3')} gap={getSpacing('4')}>
        <SidebarDebugIcon />
        <AvatarMenuWithButton />
      </Box>
    </>
  );
}
